export default __webpack_public_path__ + "static/media/godaddy2.e75f4653.svg";